import { render, staticRenderFns } from "./welfare.vue?vue&type=template&id=647b95de&scoped=true&"
import script from "./welfare.vue?vue&type=script&lang=js&"
export * from "./welfare.vue?vue&type=script&lang=js&"
import style0 from "./welfare.vue?vue&type=style&index=0&id=647b95de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b95de",
  null
  
)

export default component.exports